import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const piCreateIssueEmbedRoute: InvariantJiraRoute = {
	name: 'pi-issue-create-embed',
	path: '/jira/issues/create/pi/embed',
};
